import { isNonEmptyObject } from '@/utils/checks'
import { getIndexTypeForTerm } from '@/domain/term/useCases/getIndexTypeForTerm'
import { IndexType } from '@/domain/seo/constants'
import { Term } from '@/types/models/Term.model'
import { BrowseItemProps } from '@/components/organisms/BrowseBy/BrowseByLinkItem'
import { LOCATION_TYPE } from '../location/constants'

export const INDEX_TYPES_TO_HIDE_BROWSE_BY = [
  IndexType.NO_CITY_FACET,
  IndexType.NO_FACET
]
const MIN_COUNT_FOR_FACET_PAGE = 10

export const shouldDirectToFacetPage = ({
  item,
  term
}: {
  item: BrowseItemProps
  term: Term
}) => {
  if (!isNonEmptyObject(term)) {
    // handles index page case
    return true
  }
  const indexType = getIndexTypeForTerm(term)

  if (
    (isNonEmptyObject(item) && item.count < MIN_COUNT_FOR_FACET_PAGE) ||
    indexType === IndexType.NO_INDEX ||
    indexType === IndexType.NO_FACET
  ) {
    return false
  }
  if (
    indexType === IndexType.NO_CITY_FACET &&
    item.locationType === LOCATION_TYPE.CITY
  ) {
    return false
  }
  return true
}
